import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth     = inject(AuthService);
  const router   = inject(Router);
  const required = route.data['roles'] as string[] | undefined;
  if (!required || required.length === 0) return true;
  const allowed = required.some(r => auth.hasRole(r));
  if (!allowed) router.navigate(['/app/dashboard']);
  return allowed;
};
